import React, { useState } from "react";
import "./Carousel.css";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";
import entrada from '../../img/entrada.jpeg';
import oficina from '../../img/oficina.jpg';
import gallery1 from '../../img/gallery1.jpg';
import gallery2 from '../../img/gallery2.jpg';
import gallery3 from '../../img/gallery3.jpg';
import gallery4 from '../../img/gallery4.jpg';

const Carousel = () => {
    const images = [
        { src: entrada, alt: "Entrada da Oficina" },
        { src: oficina, alt: "Interior da Oficina" },
        { src: gallery1, alt: "Detalhe da Oficina 1" },
        { src: gallery2, alt: "Detalhe da Oficina 2" },
        { src: gallery3, alt: "Detalhe da Oficina 3" },
        { src: gallery4, alt: "Detalhe da Oficina 4" }
    ];
    const [slide, setSlide] = useState(0);

    const nextSlide = () => {
        setSlide((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    const prevSlide = () => {
        setSlide((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    return (
        <section className="carousel-section">
            <div className="section-header">
                <h2 className="section-title">NOSSA <span className="highlight">ESTRUTURA</span></h2>
                <div className="divider"></div>
            </div>

            <div className="carousel-container">
                <button className="carousel-arrow left" onClick={prevSlide}>
                    <ChevronLeft size={32} />
                </button>

                <div className="carousel-viewport">
                    <AnimatePresence mode="wait">
                        <motion.img
                            key={slide}
                            src={images[slide].src}
                            alt={images[slide].alt}
                            initial={{ opacity: 0, x: 20 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: -20 }}
                            transition={{ duration: 0.5 }}
                            className="carousel-image"
                        />
                    </AnimatePresence>
                </div>

                <button className="carousel-arrow right" onClick={nextSlide}>
                    <ChevronRight size={32} />
                </button>

                <div className="carousel-indicators">
                    {images.map((_, idx) => (
                        <button
                            key={idx}
                            onClick={() => setSlide(idx)}
                            className={`indicator ${slide === idx ? "active" : ""}`}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Carousel;